import React, { useState } from "react";

import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../context/StateContext";
import { WidgetFilter } from "../../../../models/widget.filter";
import DashboardService from "../../../../services/dashboard.service";
import { formatThousandsWithComma } from "../../../../util/formatThousandsWithComma";
import { useStyles } from "./styles";

type Props = {
  widgetFilter?: WidgetFilter;
};

/** Default Functional Component */
export default function AvgContainerPerWeek({ widgetFilter }: Props) {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const [total, setTotal] = useState<number>(0);

  useQuery(
    ["dashboard.container.avg.container", widgetFilter],
    () =>
      DashboardService.getContainerAvgPerWeekCount({
        dateFrom: widgetFilter?.dateFrom,
        dateTo: widgetFilter?.dateTo,
        companyId: currentUser?.companyId,
      }),
    {
      onSuccess: (response) => {
        if (response && response.data) setTotal(response.data);
      },
    }
  );

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} gutterBottom data-cy="avgContainerPerWeek">
        {translate("avgContainerPerWeek")}
      </Typography>

      <Typography
        className={classes.lblFigures}
        variant="h5"
        component="h2"
        align="left"
        data-cy="avgContainerPerWeekTotal"
      >
        {formatThousandsWithComma(String(total))}
      </Typography>
    </Box>
  );
}
